export function createMessage(success, message, result, status = 0) {
    return {
        success,
        message,
        result,
        status
    }
}